var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-wrap"},[_c('div',{staticClass:"wraper"},[_c('div',{staticClass:"steps"},[_c('img',{staticClass:"img",attrs:{"src":_vm.img1}}),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.img2}})])]),_c('bottom',{staticStyle:{"flex":"0 0 2.2rem"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }